import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-welcome-onboarding',
  templateUrl: './onboarding-root.component.html',
  styleUrls: ['./onboarding-root.component.scss']
})
export class OnboardingRootComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
